import { httpSession, resetHttpSession } from "./http_session";
import { Result } from "../helper/result";
import { ValidationModel } from "../model/validation_model";

export enum HttpMethod {
  GET = "GET",
  POST = "POST",
  DELETE = "DELETE",
  PUT = "PUT"
}
export class HttpError extends Error {
  status: number;
  error: any;
  constructor(error: any, status: number) {
    super(error);
    this.error = error;
    this.status = status;
  }
}

export class HttpRepository {
  private server = process.env.REACT_APP_API_URL || "http://localhost:4001/api";
  private async fetchResult<T>(method: HttpMethod, url: string, body?: BodyInit, json = false): Promise<Result<HttpError, T>> {
    try {
      const headers: Record<string, string> = json ? { "Content-Type": "application/json" } : {};
      if (method !== HttpMethod.GET) {
        if (!httpSession.csrfToken) {
          const response = await fetch(this.server + "/auth/csrf", { credentials: "include" });
          const payload = await response.json();
          if (!response.ok) return Result.error(new HttpError(payload.error || "Не удалось проверить запрос", response.status));
          httpSession.csrfToken = payload.csrfToken;
        }
        headers["X-CSRF-Token"] = httpSession.csrfToken;
      }
      const response = await fetch(this.server + url, { method, body, headers, credentials: "include" });
      const payload = await response.json();
      if (!response.ok) {
        // Invalid login is a form error, not an expired authenticated session.
        if (response.status === 401 && url !== "/auth/login") resetHttpSession(true);
        if (response.status === 403) httpSession.csrfToken = "";
        return Result.error(new HttpError(payload.error || String(payload), response.status));
      }
      return Result.ok(payload);
    } catch (error) {
      return Result.error(new HttpError(error instanceof Error ? error.message : String(error), 0));
    }
  }
  public async _formDataRequest<T>(method: HttpMethod, url: string, data?: any): Promise<Result<HttpError, T>> {
    const formData = new FormData();
    formData.append("file", data);
    return this.fetchResult<T>(method, url, formData);
  }
  public async _jsonRequest<T>(method: HttpMethod, url: string, data?: any): Promise<Result<HttpError, T>> {
    return this.fetchResult<T>(method, url, data === undefined ? undefined : JSON.stringify(data), true);
  }
  public async _request<T>(method: HttpMethod, url: string, data?: any): Promise<Result<HttpError, T>> {
    return this.fetchResult<T>(method, url, data);
  }
}

export abstract class CoreHttpRepository extends HttpRepository {
  abstract featurePath: string;
}
export abstract class CrudHttpRepository<M extends ValidationModel> extends CoreHttpRepository {
  getPage = (page = 0) => this._jsonRequest<M[]>(HttpMethod.GET, this.featurePath + `?page=${page}`);
  edit = async (model: M) => (await model.validMessage<M>()).map((validationModel) => this._jsonRequest(HttpMethod.PUT, this.featurePath, validationModel));
  addModel = async (model: M) => (await model.validMessage<M>()).map((validationModel) => this._jsonRequest(HttpMethod.POST, this.featurePath, validationModel));
  deleteModel = async (id: string) => this._jsonRequest(HttpMethod.DELETE, this.featurePath + `?id=${id}`);
}


